import { ManyToManyLookupEdit } from '@powerportalspro/react-fluent';

// Bound to the parent `<RecordContext>` (an account) supplied by the
// docs sample envelope. Same relationship name the Blazor demo uses, so
// both stacks read the same N:N link table.
export function ManyToManyLookupEditorMainSample() {
  return <ManyToManyLookupEdit relationshipName="ppp_Account_ppp_Region_ppp_Region" />;
}
